export default ['$scope', '$rootScope', '$location', 'InvestmentAccount',
 function($scope, $rootScope, $location, InvestmentAccount) {
  this.filters = {};

  $scope.$on('$routeUpdate', () => loadAccounts());
  $rootScope.$on('refreshAccountsList', () => loadAccounts());
  $rootScope.$on('closeDialog', () => $scope.accountAssignDialog.hide());
  $scope.$watch('ctrl.filters.accountAssignment', () => loadAccounts());
  $scope.$watch('ctrl.filters.accountArchived', () => loadAccounts());

  this.setAccountForDialog = account => {
    return this.accountId = account.id;
  };

  var loadAccounts = () => {
    this.filters.accountAssignment = this.filters.accountAssignment || 'all';
    this.filters.accountArchived = this.filters.accountArchived;
    this.filters.accountType = $location.search().accountType;
    this.filters.portfolioName = $location.search().portfolioName;
    this.filters.custodian = $location.search().custodian;
    this.filters.clientSearch = $location.search().clientSearch ? $location.search().clientSearch : "";
    this.filters.accountNumberSearch = $location.search().accountNumberSearch ? $location.search().accountNumberSearch : "";
    this.filters.balance = {
      from: $location.search().balanceFrom,
      to: $location.search().balanceTo
    };
    this.filters.deposits = {
      from: $location.search().depositsFrom,
      to: $location.search().depositsTo
    };

    $location.search().orderBy = $location.search().orderBy ? $location.search().orderBy : "balance";
    $location.search().reverse = $location.search().reverse ? $location.search().reverse : true;

    if ($location.search().orderBy) { this.orderBy = $location.search().orderBy; }
    if ($location.search().reverse) { this.reverse = $location.search().reverse; }
    this.page = $location.search().page ? $location.search().page : 1;
    this.limit = $location.search().limit ? $location.search().limit : 10;
    this.search = $location.search().search ? $location.search().search : "";

    this.accounts = InvestmentAccount.get({
      filters: this.filters,
      page: this.page,
      limit: this.limit,
      orderBy: this.orderBy,
      reverse: this.reverse,
      search: this.search
    });
  };

  loadAccounts();
  return this;
}
];
